/** docs/ROADMAP.md B2 离线上传队列 — public surface. */
import { useSyncExternalStore } from "react";
import { getServerSnapshot, getSnapshot, subscribe, type QueueSnapshot } from "./store";

export type { QueuedUpload, QueuedState } from "./db";
export { indexedDbAvailable } from "./db";
export type { EnqueueInput, EnqueueResult, QueueSnapshot } from "./store";
export {
  backoffFor,
  BACKOFF_MS,
  clearQueue,
  currentQueueUser,
  enqueue,
  flush,
  isRetriableUploadError,
  onUploaded,
  removeFromQueue,
  resetQueueForTests,
  retryNow,
  setQueueUser,
  startQueue,
} from "./store";

/** The current student's queue. Re-renders whenever an entry changes state. */
export function useUploadQueue(): QueueSnapshot {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** How many takes are still waiting — the 「待上传 n 条」 chip. */
export function pendingCount(snapshot: QueueSnapshot): number {
  return snapshot.items.filter((i) => i.state !== "rejected").length;
}

/** A client-generated idempotency key for one take. */
export function newUploadKey(): string {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return `q-${crypto.randomUUID()}`;
    }
  } catch {
    /* fall through to the manual id */
  }
  return `q-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}
